import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const AdvancingUploadApi = {
  Paginated: {
    useQuery: (dto: server.dto.PaginatedAdvancingUploadInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.AdvancingUpload[]>>) => useQuery({
      queryKey: ["AdvancingUpload.Paginated", dto],
      queryFn: () => window.CoreApi.AdvancingUpload.Paginated(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedAdvancingUploadInstruction) => ["AdvancingUpload.Paginated", dto]
  }, 
  Create: {
    useQuery: (dto: server.dto.CreateAdvancingUploadInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["AdvancingUpload.Create", dto],
      queryFn: () => window.CoreApi.AdvancingUpload.Create(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.CreateAdvancingUploadInstruction) => ["AdvancingUpload.Create", dto]
  }, 
  DeleteFile: {
    useQuery: (dto: server.dto.DeleteAdvancingFileInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["AdvancingUpload.DeleteFile", dto],
      queryFn: () => window.CoreApi.AdvancingUpload.DeleteFile(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.DeleteAdvancingFileInstruction) => ["AdvancingUpload.DeleteFile", dto]
  }, 

}
